/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, NavParams, NavController, ViewController, PopoverController, ToastController, AlertController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { SessionProvider } from '../../../providers/session';
import { TradingProcessProvider } from '../../../providers/processes/trading';
import { Trading_OrderStore } from './order.store';

@Component({
  selector: 'page-trading-order',
  templateUrl: 'order.html',
})
export class Trading_OrderPage {
  @ViewChild(Content) private content: Content;
  private isBuzy = false;
  private isProcessing = false;
  
  constructor(
    // *** System
    private navParams: NavParams,
    private navCtrl: NavController,
    private viewCtrl: ViewController,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private tradingProcess: TradingProcessProvider,
    private store: Trading_OrderStore) {
    this.store.params = {
      isNew: this.navParams.data.isNew,
      orderID: this.navParams.data.orderID,
      orderSide: this.navParams.data.orderSide,
      iSINCode: this.navParams.data.iSINCode,
      account: this.session.accounts.find((account) => {
        return account.AccountID == this.navParams.data.account ? this.navParams.data.account.AccountID : this.session.data.activeAccount.AccountID;
      })
    };
   ;
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this.isBuzy = true;
     
      
      this.store.load().then(
        (succeed) => {
          this.isBuzy = false;
          this.content.resize();
          this.content.scrollToTop();
        },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    try {
      this.store.reset();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recharger les données
  private _doRefresh(refresher) {
    try {
      this.isBuzy = true;
      this.store.load(true).then(
        (result) => {
          refresher.complete();
          this.content.resize();
          this.isBuzy = false;
        },
        (error) => {
          refresher.complete();
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      refresher.complete();
      this.isBuzy = false;
    }
  }

  // *** Sélectionner le compte
  private _selectAccount(account: any) {
    try {
      this.isBuzy = true;
      this.store.params.account.CustomerID = account.CustomerID;
      this.store.params.account.AccountID = account.AccountID;
      this.store.loadPortfolio(false).then(
        (data) => {
          this.store.order.CustomerID = this.store.params.account.CustomerID;
          this.store.order.AccountID = this.store.params.account.AccountID;
          this.store.balance = data['balance'];
          this.store.instrument = data['instrument'];
          this.content.resize();
          this.isBuzy = false;
        },
        (error) => {
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
    console.log(account);
  }

  // *** Sélectionner le type de l'ordre
  private _selectOrderType(orderType: number) {
    try {
      this.isBuzy = true;
      if (orderType == 2) {
        this.store.order.Price = this.store.instrument.Price;
        this.store.order.MaxFloor = this.store.order.Quantity >= 10 ? this.store.order.Quantity : 0;
      }
      else {
        this.store.order.Price = this.store.order.OrderSide == 1 ? this.store.instrument.LowerThreshold : this.store.instrument.UpperThreshold;
        this.store.order.MaxFloor = 0;
      }
      this.isBuzy = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Définir la Quantité
  private _setQuantity(orderQuantity: number) {
    try {
      //console.log(orderQuantity);
      if (this.store.order.OrderType == 2){
            if (!orderQuantity) {
            this.store.order.Quantity = 0;
          }
          else {
            this.store.order.MaxFloor = orderQuantity >= 10 ? orderQuantity : 0;
           }
      }
           
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Sélectionner la validité de l'ordre
  private _selectOrderValidity(orderValidity: number) {
    try {
      this.isBuzy = true;
      let expireDate = new Date();
      if (orderValidity == 2)
        expireDate.setFullYear(expireDate.getFullYear() + 1);
      this.store.order.ExpireDate = expireDate.toISOString();
      this.isBuzy = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Valider l'ordre
  private _validate() {
    try {
      console.log(this.store.order);
      this.isBuzy = true;
      this.tradingProcess.validateOrder(this.store.params.isNew, this.store.order).then(
        (data) => {
          if (data['IsValid']) {
            let message = data['Summary'] ? data['Summary'].Text : '';
            message += this.store.params.isNew ? this.globals.MSG_ORDER_ADD_CONFIRM : this.globals.MSG_ORDER_REPLACE_CONFIRM;
            let alert = this.alertCtrl.create({
              title: data['Summary'] ? data['Summary'].Wording : '',
              message: message,
              buttons: [
                {
                  text: 'Non',
                  role: 'cancel',
                  handler: () => { }
                },
                {
                  text: 'Confirmer',
                  handler: () => {
                    this.isBuzy = true;
                    if (this.store.params.isNew)
                      this.tradingProcess.addOrder(this.store.order).then(
                        (data) => {
                          if (data['IsAdded'])
                            this.viewCtrl.dismiss();
                          else {
                            let alert = this.alertCtrl.create({
                              title: 'Erreur!',
                              subTitle: data['Messages'] ? data['Messages'].join('<br/>') : this.globals.MSG_UNKNOWN_ERROR,
                              buttons: ['OK']
                            });
                            alert.present();
                          }
                          this.isBuzy = false;
                        },
                        (error) => { this.isBuzy = false; }
                      );
                    else
                      this.tradingProcess.updateOrder(this.store.order).then(
                        (data) => {
                          if (data['IsUpdated'])
                            this.viewCtrl.dismiss();
                          else {
                            let alert = this.alertCtrl.create({
                              title: 'Erreur!',
                              subTitle: data['Messages'] ? data['Messages'].join('<br/>') : this.globals.MSG_UNKNOWN_ERROR,
                              buttons: ['OK']
                            });
                            alert.present();
                          }
                          this.isBuzy = false;
                        },
                        (error) => { this.isBuzy = false; }
                      );
                  }
                }
              ]
            });
            alert.present();
          }
          else {
            let alert = this.alertCtrl.create({
              title: 'Erreur!',
              subTitle: data['Messages'] ? data['Messages'].join('<br/>') : this.globals.MSG_UNKNOWN_ERROR,
              buttons: ['OK']
            });
            alert.present();
          }
          this.isBuzy = false;
        },
        (error) => {
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Incrémenter une Quantité
  private _incrQuantity(field: string) {
    let quantity = Number.parseInt(this.store.order[field]);
    quantity = quantity + 1;
    this.store.order[field] = quantity;
  }

  // *** Décrémenter une Quantité
  private _decrQuantity(field: string) {
    let quantity = Number.parseInt(this.store.order[field]);
    quantity = quantity == 0 ? 0 : quantity - 1;
    this.store.order[field] = quantity;
  }

  // *** Incrémenter le Prix
  private _decrPrice() {
    let price = Number.parseFloat(this.store.order.Price);
    price = price < 0.05 ? price : price - 0.05;
    this.store.order.Price = Math.round(price * 100) / 100;
  }

  // *** Décrémenter le Prix
  private _incrPrice() {
    let price = Number.parseFloat(this.store.order.Price);
    price = price + 0.05;
    this.store.order.Price = Math.round(price * 100) / 100;
  }
}


// WEBPACK FOOTER //
// ./src/pages/trading/order/order.ts